import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { CircularProgress } from '@mui/material';
import { green, red, yellow } from '@mui/material/colors';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { ProgressAvatarValue } from '../ComponentDesignListItem';

type Props = { value: ProgressAvatarValue };

export function ProgressAvatar({ value }: Props) {
  if (typeof value === 'number') {
    return <CircularProgress variant="determinate" value={value * 100} />;
  }

  switch (value) {
    case 'indeterminate':
      return <CircularProgress variant="indeterminate" />;

    case 'hourglass':
      return <HourglassEmptyIcon />;

    case 'success':
      return <DoneIcon sx={{ color: green[500] }} />;

    case 'success-with-warnings':
      return <DoneIcon sx={{ color: yellow[500] }} />;

    case 'failure':
      return <ErrorIcon sx={{ color: red[500] }} />;

    default:
      assertExhaustiveSwitch(value);
  }

  return null;
}
